import { batch } from 'react-redux';
import {
  GET_USERS_START,
  GET_USERS_FULFILLED,
  GET_USERS_REJECTED,
  GET_GROUPS_START,
  GET_GROUPS_FULFILLED,
  GET_GROUPS_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_JOURNAL_ENTRIES_START,
  FETCH_JOURNAL_ENTRIES_FULFILLED,
  FETCH_JOURNAL_ENTRIES_REJECTED,
  SET_SELECTED_ATHLETE,
  FETCH_ENTRIES_FOR_ATHLETE_START,
  FETCH_ENTRIES_FOR_ATHLETE_FULFILLED,
  FETCH_ENTRIES_FOR_ATHLETE_REJECTED,
  SET_CURRENT_GROUP,
  FETCH_ENTRIES_FOR_GROUP_START,
  FETCH_ENTRIES_FOR_GROUP_FULFILLED,
  FETCH_ENTRIES_FOR_GROUP_REJECTED,
  FETCH_ME_JOURNAL_ENTRIES_START,
  FETCH_ME_JOURNAL_ENTRIES_FULFILLED,
  FETCH_ME_JOURNAL_ENTRIES_REJECTED,
  FETCH_NEXT_JOURNAL_PAGE_START,
  FETCH_NEXT_JOURNAL_PAGE_FULFILLED,
  FETCH_NEXT_JOURNAL_PAGE_REJECTED,
  CREATE_JOURNAL_ENTRIES_START,
  CREATE_JOURNAL_ENTRIES_FULFILLED,
  CREATE_JOURNAL_ENTRIES_REJECTED,
  RESET_ENTRY_ERROR,
  CREATE_ENTRY_TO_ATHLETE_START,
  CREATE_ENTRY_TO_ATHLETE_FULFILLED,
  CREATE_ENTRY_TO_ATHLETE_REJECTED,
  SET_EDIT_JOURNAL_ENTRY,
  UPDATE_JOURNAL_ENTRY_START,
  UPDATE_JOURNAL_ENTRY_FULFILLED,
  UPDATE_JOURNAL_ENTRY_REJECTED,
  DELETE_ME_JOURNAL_ENTRIES_START,
  DELETE_ME_JOURNAL_ENTRIES_FULFILLED,
  DELETE_ME_JOURNAL_ENTRIES_REJECTED,
  SET_FILTER_OPTIONS,
  SET_IS_END_OF_LIST,
  SET_EXERCISE_TAB,
  SET_TEMP_EXERCISE,
  UPLOAD_MEDIA_START,
  UPLOAD_MEDIA_FULFILLED,
  UPLOAD_MEDIA_REJECTED,
  SET_UPLOAD_MEDIA_FALSE,
  UPLOAD_COMMENT_MEDIA_START,
  UPLOAD_COMMENT_MEDIA_FULFILLED,
  UPLOAD_COMMENT_MEDIA_REJECTED,
  UPLOAD_COMMENT_MEDIA_URL_START,
  UPLOAD_COMMENT_MEDIA_URL_FULFILLED,
  UPLOAD_COMMENT_MEDIA_URL_REJECTED,
  SET_UPLOAD_COMMENT_MEDIA_FALSE,
  SET_COMMENT_MEDIA_TARGET,
  SET_REMOVE_MEDIA_ARRAY,
  CLEAR_REMOVE_MEDIA_ARRAY,
  SET_MESSAGE_MEDIA_URL,
  SET_ACTIVE_REDUX_MODAL,
  SET_SUB_ACTIVE_REDUX_MODAL,
  SET_JOURNAL_TAB,
  CREATE_JOURNAL_ENTRY_COMMENT_START,
  CREATE_JOURNAL_ENTRY_COMMENT_FULFILLED,
  CREATE_JOURNAL_ENTRY_COMMENT_REJECTED,
  RESET_COMMENT_ERROR,
  SET_EDIT_COMMENT,
  EDIT_JOURNAL_ENTRY_COMMENT_START,
  EDIT_JOURNAL_ENTRY_COMMENT_FULFILLED,
  EDIT_JOURNAL_ENTRY_COMMENT_REJECTED,
  DELETE_JOURNAL_ENTRY_COMMENT_START,
  DELETE_JOURNAL_ENTRY_COMMENT_FULFILLED,
  DELETE_JOURNAL_ENTRY_COMMENT_REJECTED,
  SET_REPORT_POST_ID,
  SUBMIT_SUPPORT_START,
  SUBMIT_SUPPORT_FULFILLED,
  SUBMIT_SUPPORT_REJECTED,
  RESET_SUPPORT_ERROR,
} from './actionTypes';

import { showErrorToast, showSuccessToast } from '../../../shared/utils/toastManager';
import { axiosAuthed } from '../../../shared/utils/setCommonHeaders';
import { authProvider } from '../../login/ducks/loginActions';

authProvider();

export const getUsers = (accountCode) => (dispatch) => {
  dispatch({ type: GET_USERS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/users`)
    .then((response) => {
      dispatch({
        type: GET_USERS_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_USERS_REJECTED,
        payload: err,
      });
    });
};

export const getGroups = (accountCode) => (dispatch) => {
  dispatch({ type: GET_GROUPS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/groups`)
    .then((response) => {
      dispatch({
        type: GET_GROUPS_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_GROUPS_REJECTED,
        payload: err,
      });
    });
};

// get journalEntries for all athletes
export const getJournalEntriesForAllAthletes = (accountCode) => (
  dispatch,
  getState,
) => {
  const { dateRange, mediaOnly, filterExercise } = getState().journal.data;
  const dateRangeStart = dateRange && dateRange.startDate?._d;
  const dateRangeEnd = dateRange && dateRange.endDate?._d;

  // date dateRangeStart and dateRangeEnd are already in YYYY-MM-DD format
  let dateRangeQuery = '';
  if (dateRangeStart && dateRangeEnd) {
    dateRangeQuery = `?dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`;
  }

  // exerciseId Query
  let exerciseIdQuery = '';
  if (filterExercise.id) {
    exerciseIdQuery = dateRangeQuery
      ? `&exerciseId=${filterExercise.id}`
      : `?exerciseId=${filterExercise.id}`;
  }

  // mediaOnly Query
  let mediaOnlyQuery = '';
  if (mediaOnly) {
    const hasExistingParams = dateRangeQuery || filterExercise.id;
    mediaOnlyQuery = hasExistingParams ? '&mediaOnly=true' : '?mediaOnly=true';
  }

  dispatch({ type: FETCH_JOURNAL_ENTRIES_START });

  axiosAuthed
    .get(
      `/accounts/${accountCode}/journals/entries${dateRangeQuery}${exerciseIdQuery}${mediaOnlyQuery}`,
    )
    .then((response) => {
      const isEndOfList = response.data.length < 50;

      const filteredData = response.data.filter(
        (journalEntry) => journalEntry.private === false,
      );

      dispatch({
        type: FETCH_JOURNAL_ENTRIES_FULFILLED,
        payload: { filteredData, isEndOfList, mediaOnly },
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_JOURNAL_ENTRIES_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error fetching the journal entries. Please try again.',
      );
    });
};

export const fetchNextPageForAthletes = (accountCode, currentPage) => (
  dispatch,
  getState,
) => {
  const { dateRange, mediaOnly, filterExercise } = getState().journal.data;
  const dateRangeStart = dateRange && dateRange.startDate?._d;
  const dateRangeEnd = dateRange && dateRange.endDate?._d;
  dispatch({ type: FETCH_NEXT_JOURNAL_PAGE_START });

  const page = currentPage + 1;
  const infiniteLoadQuery = `?page=${page}`;

  // if there are date ranges then add that to the query
  let dateRangeQuery = '';
  if (dateRangeStart && dateRangeEnd) {
    dateRangeQuery = `?dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`;
  }

  // exerciseId Query
  const exerciseIdQuery = filterExercise.id
    ? `&exerciseId=${filterExercise.id}`
    : '';

  // mediaOnly Query
  const mediaOnlyQuery = mediaOnly ? '&mediaOnly=true' : '';

  axiosAuthed
    .get(
      `/accounts/${accountCode}/journals/entries${infiniteLoadQuery}${dateRangeQuery}${exerciseIdQuery}${mediaOnlyQuery}`,
    )
    .then((response) => {
      const isEndOfList = response.data.length < 50;
      if (response.data.length === 0) {
        return;
      }
      // eslint-disable-next-line radix
      const filteredData = response.data.filter(
        (journalEntry) => journalEntry.private === false,
      );

      dispatch({
        type: FETCH_NEXT_JOURNAL_PAGE_FULFILLED,
        payload: {
          data: filteredData,
          page: response.data.length === 0 ? currentPage : page,
          isEndOfList,
          mediaOnly,
        },
      });
    })
    .catch((err) => {
      // we need this specific catch error if the entries = exactly 50 and are then end of
      // the list, we need to set the global state for isEndOfList to true
      //  if we don't catch this it will be an infinite loop calling the api for the
      // next page
      if (err.response.data.length === 0) {
        dispatch({
          type: SET_IS_END_OF_LIST,
          payload: { isEndOfList: true },
        });
      }
      dispatch({
        type: FETCH_NEXT_JOURNAL_PAGE_REJECTED,
        payload: err,
      });
    });
};

export const setSelectedAthlete = (athlete) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_ATHLETE,
    payload: athlete,
  });
};

export const getJournalEntriesForAthlete = (accountCode) => (
  dispatch,
  getState,
) => {
  const {
    dateRange,
    mediaOnly,
    filterExercise,
    currentAthlete,
  } = getState().journal.data;
  const { currentUser } = getState().auth.data;
  const dateRangeStart = dateRange && dateRange.startDate?._d;
  const dateRangeEnd = dateRange && dateRange.endDate?._d;  
  // date dateRangeStart and dateRangeEnd are already in YYYY-MM-DD format
  let dateRangeQuery = '';
  if (dateRangeStart && dateRangeEnd) {
    dateRangeQuery = `?dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`;
  }

  // exerciseId Query
  const exerciseIdQuery = filterExercise.id
    ? `&exerciseId=${filterExercise.id}`
    : '';

  // mediaOnly Query
  const mediaOnlyQuery = mediaOnly ? '&mediaOnly=true' : '';

  dispatch({ type: FETCH_ENTRIES_FOR_ATHLETE_START });

  axiosAuthed
    .get(
      `/accounts/${accountCode}/journals/entries/?userId=${currentAthlete.id}${dateRangeQuery}${exerciseIdQuery}${mediaOnlyQuery}`,
    )
    .then((response) => {
      // eslint-disable-next-line radix
      const isEndOfList = response.data.length < 50;
      const filterForNotPrivate = response.data.filter(
        (entry) => entry.private === false
          || (entry.private === true && entry.createdByUserId === currentUser.id),
      );
      // eslint-disable-next-line radix
      dispatch({
        type: FETCH_ENTRIES_FOR_ATHLETE_FULFILLED,
        payload: { filterForNotPrivate, isEndOfList, mediaOnly },
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_ENTRIES_FOR_ATHLETE_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error fetching the journal entries. Please try again.',
      );
    });
};

export const fetchNextPageForAthlete = (accountCode, currentPage) => (
  dispatch,
  getState,
) => {
  const {
    dateRange,
    mediaOnly,
    filterExercise,
    currentAthlete,
  } = getState().journal.data;
  const { currentUser } = getState().auth.data;
  const dateRangeStart = dateRange && dateRange.startDate?._d;
  const dateRangeEnd = dateRange && dateRange.endDate?._d;
  dispatch({ type: FETCH_NEXT_JOURNAL_PAGE_START });

  const page = currentPage + 1;
  const infiniteLoadQuery = `&page=${page}`;
  // if there are date ranges then add that to the query
  let dateRangeQuery = '';
  if (dateRangeStart && dateRangeEnd) {
    dateRangeQuery = `?dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`;
  }

  // exerciseId Query
  const exerciseIdQuery = filterExercise.id
    ? `&exerciseId=${filterExercise.id}`
    : '';

  // mediaOnly Query
  const mediaOnlyQuery = mediaOnly ? '&mediaOnly=true' : '';

  axiosAuthed
    .get(
      `/accounts/${accountCode}/journals/entries?userId=${currentAthlete.id}${infiniteLoadQuery}${dateRangeQuery}${exerciseIdQuery}${mediaOnlyQuery}`,
    )
    .then((response) => {
      const isEndOfList = response.data.length < 50;
      if (response.data.length === 0) {
        return;
      }
      // eslint-disable-next-line radix
      const filterForNotPrivate = response.data.filter(
        (entry) => entry.private === false
          || (entry.private === true && entry.createdByUserId === currentUser.id),
      );

      dispatch({
        type: FETCH_NEXT_JOURNAL_PAGE_FULFILLED,
        payload: {
          data: filterForNotPrivate,
          page: response.data.length === 0 ? currentPage : page,
          isEndOfList,
          mediaOnly,
        },
      });
    })
    .catch((err) => {
      // we need this specific catch error if the entries = exactly 50 and are then end of
      // the list, if we don't catch this it will be an infinite loop calling the api for the
      // next page
      if (err.response.data.length === 0) {
        dispatch({
          type: SET_IS_END_OF_LIST,
          payload: { isEndOfList: true },
        });
      }
      dispatch({
        type: FETCH_NEXT_JOURNAL_PAGE_REJECTED,
        payload: err,
      });
    });
};

export const setCurrentGroup = (groupId, groupName) => ({
  type: SET_CURRENT_GROUP,
  payload: { name: groupName, id: groupId },
});

export const getJournalEntriesForGroup = (accountCode) => (
  dispatch,
  getState,
) => {
  const {
    dateRange,
    mediaOnly,
    filterExercise,
    currentGroup,
  } = getState().journal.data;
  const groupId = currentGroup.id || '';
  const dateRangeStart = dateRange && dateRange.startDate?._d;
  const dateRangeEnd = dateRange && dateRange.endDate?._d;

  // date dateRangeStart and dateRangeEnd are already in YYYY-MM-DD format
  let dateRangeQuery = '';
  if (dateRangeStart && dateRangeEnd) {
    dateRangeQuery = `?dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`;
  }

  // exerciseId Query
  const exerciseIdQuery = filterExercise.id
    ? `&exerciseId=${filterExercise.id}`
    : '';

  // mediaOnly Query
  const mediaOnlyQuery = mediaOnly ? '&mediaOnly=true' : '';

  dispatch({ type: FETCH_ENTRIES_FOR_GROUP_START });

  axiosAuthed
    .get(
      `/accounts/${accountCode}/journals/entries/?groupId=${groupId}${dateRangeQuery}${exerciseIdQuery}${mediaOnlyQuery}`,
    )
    .then((response) => {
      // eslint-disable-next-line radix
      const isEndOfList = response.data.length < 50;
      const filterForNotPrivate = response.data.filter(
        (
          entry,
          // eslint-disable-next-line radix
        ) => entry.private === false,
      );
      dispatch({
        type: FETCH_ENTRIES_FOR_GROUP_FULFILLED,
        payload: { filterForNotPrivate, isEndOfList, mediaOnly },
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_ENTRIES_FOR_GROUP_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error fetching the journal entries. Please try again.',
      );
    });
};

export const fetchNextPageForGroup = (accountCode, currentPage) => (
  dispatch,
  getState,
) => {
  const {
    dateRange,
    mediaOnly,
    filterExercise,
    currentGroup,
  } = getState().journal.data;
  const groupId = currentGroup.id || '';
  const dateRangeStart = dateRange && dateRange.startDate?._d;
  const dateRangeEnd = dateRange && dateRange.endDate?._d;
  const page = currentPage + 1;
  const infiniteLoadQuery = `&page=${page}`;
  // if there are date ranges then add that to the query
  let dateRangeQuery = '';
  if (dateRangeStart && dateRangeEnd) {
    dateRangeQuery = `?dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`;
  }

  // exerciseId Query
  const exerciseIdQuery = filterExercise.id
    ? `&exerciseId=${filterExercise.id}`
    : '';

  // mediaOnly Query
  const mediaOnlyQuery = mediaOnly ? '&mediaOnly=true' : '';

  dispatch({ type: FETCH_NEXT_JOURNAL_PAGE_START });

  axiosAuthed
    .get(
      `/accounts/${accountCode}/journals/entries?groupId=${groupId}${infiniteLoadQuery}${dateRangeQuery}${exerciseIdQuery}${mediaOnlyQuery}`,
    )
    .then((response) => {
      const isEndOfList = response.data.length < 50;
      if (response.data.length === 0) {
        return;
      }
      // eslint-disable-next-line radix
      const filterForNotPrivate = response.data.filter(
        (
          entry,
          // eslint-disable-next-line radix
        ) => entry.private === false,
      );

      dispatch({
        type: FETCH_NEXT_JOURNAL_PAGE_FULFILLED,
        payload: {
          data: filterForNotPrivate,
          page: response.data.length === 0 ? currentPage : page,
          isEndOfList,
          mediaOnly,
        },
      });
    })
    .catch((err) => {
      // we need this specific catch error if the entries = exactly 50 and are then end of
      // the list, if we don't catch this it will be an infinite loop calling the api for the
      // next page
      if (err.response.data.length === 0) {
        dispatch({
          type: SET_IS_END_OF_LIST,
          payload: { isEndOfList: true },
        });
      }
      dispatch({
        type: FETCH_NEXT_JOURNAL_PAGE_REJECTED,
        payload: err,
      });
    });
};

export const getMeJournalEntries = (accountCode) => (dispatch, getState) => {
  const { dateRange, mediaOnly, filterExercise } = getState().journal.data;
  const { currentUser } = getState().auth.data;
  const dateRangeStart = dateRange && dateRange.startDate?._d;
  const dateRangeEnd = dateRange && dateRange.endDate?._d;
  // date dateRangeStart and dateRangeEnd are already in YYYY-MM-DD format
  let dateRangeQuery = '';
  if (dateRangeStart && dateRangeEnd) {
    dateRangeQuery = `?dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`;
  }

  // exerciseId Query
  let exerciseIdQuery = '';
  if (filterExercise.id) {
    exerciseIdQuery = dateRangeQuery
      ? `&exerciseId=${filterExercise.id}`
      : `?exerciseId=${filterExercise.id}`;
  }

  // mediaOnly Query
  let mediaOnlyQuery = '';
  if (mediaOnly) {
    const hasExistingParams = dateRangeQuery || filterExercise.id;
    mediaOnlyQuery = hasExistingParams ? '&mediaOnly=true' : '?mediaOnly=true';
  }

  dispatch({ type: FETCH_ME_JOURNAL_ENTRIES_START });

  axiosAuthed
    .get(
      `/me/accounts/${accountCode}/journals/entries${dateRangeQuery}${exerciseIdQuery}${mediaOnlyQuery}`,
    )
    .then((response) => {
      const { data } = response;
      const isEndOfList = response.data.length < 50;
      dispatch({
        type: FETCH_ME_JOURNAL_ENTRIES_FULFILLED,
        payload: {
          data,
          isEndOfList,
          mediaOnly,
          currentUser,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_ME_JOURNAL_ENTRIES_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error fetching the journal entries. Please try again.',
      );
    });
};

export const fetchNextPageMyJournal = (accountCode, currentPage) => (
  dispatch,
  getState,
) => {
  const { dateRange, mediaOnly, filterExercise } = getState().journal.data;
  const dateRangeStart = dateRange && dateRange.startDate?._d;
  const dateRangeEnd = dateRange && dateRange.endDate?._d;
  dispatch({ type: FETCH_NEXT_JOURNAL_PAGE_START });

  const page = currentPage + 1;
  const infiniteLoadQuery = `?page=${page}`;

  // if there are date ranges then add that to the query
  let dateRangeQuery = '';
  if (dateRangeStart && dateRangeEnd) {
    dateRangeQuery = `?dateRangeStart=${dateRangeStart}&dateRangeEnd=${dateRangeEnd}`;
  }

  // exerciseId Query
  const exerciseIdQuery = filterExercise.id
    ? `&exerciseId=${filterExercise.id}`
    : '';

  // mediaOnly Query
  const mediaOnlyQuery = mediaOnly ? '&mediaOnly=true' : '';

  axiosAuthed
    .get(
      `/me/accounts/${accountCode}/journals/entries${infiniteLoadQuery}${dateRangeQuery}${exerciseIdQuery}${mediaOnlyQuery}`,
    )
    .then((response) => {
      const isEndOfList = response.data.length < 50;
      dispatch({
        type: FETCH_NEXT_JOURNAL_PAGE_FULFILLED,
        payload: {
          data: response.data,
          page: response.data.length === 0 ? currentPage : page,
          isEndOfList,
          mediaOnly,
        },
      });
    })
    .catch((err) => {
      // we need this specific catch error if the entries = exactly 50 and are then end of
      // the list, if we don't catch this it will be an infinite loop calling the api for the
      // next page
      if (err.response.data.length === 0) {
        dispatch({
          type: SET_IS_END_OF_LIST,
          payload: { isEndOfList: true },
        });
      }
      dispatch({
        type: FETCH_NEXT_JOURNAL_PAGE_REJECTED,
        payload: err,
      });
    });
};

export const setEditJournalEntry = (entryObj) => (dispatch) => {
  const entryMediaArray = entryObj.media;
  const entryMediaIds = entryObj.media?.map((mediaObj) => mediaObj.id);
  dispatch({
    type: SET_EDIT_JOURNAL_ENTRY,
    payload: {
      entry: entryObj,
      mediaIds: entryMediaIds,
      media: entryMediaArray,
    },
  });
};

export const setFilterOptions = (
  mediaOnly = false,
  startDate = null,
  endDate = null,
  exercise = {},
) => (dispatch) => {
  dispatch({
    type: SET_FILTER_OPTIONS,
    payload: {
      mediaOnly,
      startDate,
      endDate,
      exercise,
    },
  });
};

export const setExerciseTab = (exerciseType, accountCode) => (dispatch) => {
  dispatch({
    type: SET_EXERCISE_TAB,
    payload: exerciseType,
  });
  dispatch({ type: FETCH_EXERCISES_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/exercises?type=${exerciseType}`)
    .then((response) => {
      dispatch({
        type: FETCH_EXERCISES_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_EXERCISES_REJECTED,
        payload: err,
      });
    });
};

export const setTempExercise = (exercise) => (dispatch) => {
  dispatch({
    type: SET_TEMP_EXERCISE,
    payload: exercise,
  });
};

export const uploadMedia = (values) => (dispatch) => {
  const formData = new FormData();
  formData.append(values.type, values.acceptedFile[0]);
  dispatch({ type: UPLOAD_MEDIA_START });
  axiosAuthed
    .post(`/media/upload/${values.type}`, formData)
    .then((response) => {
      dispatch({
        type: UPLOAD_MEDIA_FULFILLED,
        payload: response.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: UPLOAD_MEDIA_REJECTED,
        payload: err,
      });
      showErrorToast('There was an error uploading the media. Please try again.');
    });
};

export const setUploadMediaFalse = () => ({
  type: SET_UPLOAD_MEDIA_FALSE,
});

export const uploadCommentMedia = (values, entryId, commentId) => (
  dispatch,
) => {
  const formData = new FormData();
  formData.append(values.type, values.acceptedFile[0]);
  dispatch({
    type: UPLOAD_COMMENT_MEDIA_START,
    payload: {
      entryId,
      commentId,
    },
  });
  axiosAuthed
    .post(`/media/upload/${values.type}`, formData)
    .then((response) => {
      dispatch({
        type: UPLOAD_COMMENT_MEDIA_FULFILLED,
        payload: {
          media: response.data,
          entryId,
          commentId,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: UPLOAD_COMMENT_MEDIA_REJECTED,
        payload: err,
      });
      showErrorToast('There was an error uploading the media. Please try again.');
    });
};

export const uploadCommentMediaUrl = (values, entryId, commentId) => (
  dispatch,
) => {
  dispatch({
    type: UPLOAD_COMMENT_MEDIA_URL_START,
    payload: {
      entryId,
      commentId,
    },
  });
  axiosAuthed
    .post('/media/url', values)
    .then((response) => {
      dispatch({
        type: UPLOAD_COMMENT_MEDIA_URL_FULFILLED,
        payload: {
          media: response.data,
          entryId,
          commentId,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: UPLOAD_COMMENT_MEDIA_URL_REJECTED,
        payload: err,
      });
      showErrorToast('There was an error uploading the media. Please try again.');
    });
};

export const setUploadCommentMediaFalse = () => ({
  type: SET_UPLOAD_COMMENT_MEDIA_FALSE,
});

export const setCommentMediaTarget = (ids) => (dispatch) => {
  dispatch({
    type: SET_COMMENT_MEDIA_TARGET,
    payload: {
      entryId: ids.entryId,
      commentId: ids.commentId,
    },
  });
};

export const setRemoveMediaArray = (mediaId) => ({
  type: SET_REMOVE_MEDIA_ARRAY,
  payload: mediaId,
});

export const clearRemoveMediaArray = () => ({
  type: CLEAR_REMOVE_MEDIA_ARRAY,
});

export const openImageLightbox = (mediaUrl) => (dispatch) => {
  dispatch({
    type: SET_MESSAGE_MEDIA_URL,
    payload: mediaUrl,
  });
  dispatch({
    type: SET_SUB_ACTIVE_REDUX_MODAL,
    payload: 'image-lightbox',
  });
};

export const openMessageVideo = (mediaUrl) => (dispatch) => {
  batch(() => {
    dispatch({
      type: SET_MESSAGE_MEDIA_URL,
      payload: mediaUrl,
    });
    dispatch({
      type: SET_SUB_ACTIVE_REDUX_MODAL,
      payload: 'play-message-video-modal',
    });
  })
};

export const setActiveReduxModal = (activeModal) => ({
  type: SET_ACTIVE_REDUX_MODAL,
  payload: activeModal,
});

export const setSubActiveReduxModal = (activeSubModal) => ({
  type: SET_SUB_ACTIVE_REDUX_MODAL,
  payload: activeSubModal,
});

export const setJournalTab = (tabName) => (dispatch) => {
  if (tabName !== 'SINGLE_ATHLETE') {
    dispatch({
      type: SET_SELECTED_ATHLETE,
      payload: {},
    });
  }
  dispatch({
    type: SET_JOURNAL_TAB,
    payload: tabName,
  });
};

export const createMeJournalEntry = (accountCode, values, onSuccess) => (dispatch) => {
  dispatch({ type: CREATE_JOURNAL_ENTRIES_START });

  axiosAuthed
    .post(`/me/accounts/${accountCode}/journals/entries`, values)
    .then((response) => {
      dispatch({
        type: CREATE_JOURNAL_ENTRIES_FULFILLED,
        payload: response.data,
      });
      if (onSuccess) {
        onSuccess();
      }
      showSuccessToast('Entry created successfully!');
    })
    .catch((err) => {
      dispatch({
        type: CREATE_JOURNAL_ENTRIES_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error creating your journal entry. Please try again.',
      );
    });
};

export const createEntryToAthlete = (accountCode, values, onSuccess) => (dispatch) => {
  dispatch({ type: CREATE_ENTRY_TO_ATHLETE_START });

  axiosAuthed
    .post(`/accounts/${accountCode}/journals/entries`, values)
    .then((response) => {
      dispatch({
        type: CREATE_ENTRY_TO_ATHLETE_FULFILLED,
        payload: response.data,
      });
      if (onSuccess) {
        onSuccess();
      }
      showSuccessToast('Entry created successfully!');
    })
    .catch((err) => {
      dispatch({
        type: CREATE_ENTRY_TO_ATHLETE_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error creating your journal entry. Please try again.',
      );
    });
};

export const updateJournalEntry = (accountCode, values, entryId) => (
  dispatch,
  getState,
) => {
  const { currentJournalEntry } = getState().journal.data;
  const { currentUser } = getState().auth.data;

  const myJournal = currentJournalEntry.userId === currentUser.id;
  const uri = myJournal
    ? `/me/accounts/${accountCode}/journals/entries/${entryId}`
    : `/accounts/${accountCode}/journals/entries/${entryId}`;

  dispatch({ type: UPDATE_JOURNAL_ENTRY_START });

  axiosAuthed
    .put(uri, values)
    .then((response) => {
      dispatch({
        type: UPDATE_JOURNAL_ENTRY_FULFILLED,
        payload: response.data,
      });
      showSuccessToast('Journal entry updated successfully.');
    })
    .catch((err) => {
      dispatch({
        type: UPDATE_JOURNAL_ENTRY_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error updating the journal entry. Please try again.',
      );
    });
};

export const resetEntryError = () => (dispatch) => {
  dispatch({
    type: RESET_ENTRY_ERROR,
  });
};

export const deleteMeJournalEntries = (accountCode, values) => (dispatch) => {
  // values will be journalEntryIds:[]
  dispatch({ type: DELETE_ME_JOURNAL_ENTRIES_START });
  axiosAuthed
    .patch(`/me/accounts/${accountCode}/journals/entries/delete`, values)
    .then((response) => {
      if (response.data.errors?.length) {
        dispatch({
          type: DELETE_ME_JOURNAL_ENTRIES_REJECTED,
          payload: response.data.errors[0],
        });
        showErrorToast(
          'There was an error deleting the journal entry. Please try again.',
        );
      } else {
        dispatch({
          type: DELETE_ME_JOURNAL_ENTRIES_FULFILLED,
          payload: response.data,
        });
        showSuccessToast('Journal entry deleted successfully.');
      }
    })
    .catch((err) => {
      dispatch({
        type: DELETE_ME_JOURNAL_ENTRIES_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error deleting the journal entry. Please try again.',
      );
    });
};

export const createJournalEntryComment = (accountCode, values) => (
  dispatch,
  getState,
) => {
  const { currentUser } = getState().auth.data;
  const { currentAthlete } = getState().journal.data;
  dispatch({ type: CREATE_JOURNAL_ENTRY_COMMENT_START });
  let uri = `/accounts/${accountCode}/journals/entries/${values.entryId}/comments`;
  if (
    currentUser.admin < 1
    || (currentAthlete?.id === currentUser?.id)
  ) {
    uri = `/me${uri}`;
  }
  axiosAuthed
    .post(uri, values.submissionObj)
    .then((response) => {
      dispatch({
        type: CREATE_JOURNAL_ENTRY_COMMENT_FULFILLED,
        payload: {
          data: response.data,
          journalEntryId: values.entryId,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: CREATE_JOURNAL_ENTRY_COMMENT_REJECTED,
        payload: {
          entryId: values.entryId,
          err,
        },
      });
      showErrorToast(
        'There was an error creating your comment. Please try again.',
      );
    });
};

export const resetCommentError = () => (dispatch) => {
  dispatch({
    type: RESET_COMMENT_ERROR,
  });
};

export const setEditComment = (commentObj) => (dispatch, getState) => {
  const { journalEntriesData } = getState().journal.data;
  const { media } = journalEntriesData
    .find((entry) => entry.id === commentObj.entryId)
    .comments.find((comment) => comment.id === commentObj.comment.id);

  dispatch({
    type: SET_EDIT_COMMENT,
    payload: {
      entryId: commentObj.entryId,
      comment: commentObj.comment,
      mediaObj: media
        ? {
          commentId: commentObj.comment.id,
          entryId: commentObj.entryId,
          media,
        }
        : {},
    },
  });
};

export const clearEditComment = () => (dispatch) => {
  dispatch({
    type: SET_EDIT_COMMENT,
    payload: {
      entryId: null,
      comment: {},
      mediaObj: {},
    },
  });
};

export const editJournalEntryComment = (accountCode, values) => (
  dispatch,
  getState,
) => {
  const { currentUser } = getState().auth.data;
  const { currentAthlete } = getState().journal.data;
  dispatch({ type: EDIT_JOURNAL_ENTRY_COMMENT_START });
  let uri = `/accounts/${accountCode}/journals/entries/${values.entryId}/comments/${values.commentId}`;
  if (
    currentUser.admin < 1
    || (currentAthlete?.id === currentUser?.id)
  ) {
    uri = `/me${uri}`;
  }
  axiosAuthed
    .put(uri, values.submissionObj)
    .then((response) => {
      dispatch({
        type: EDIT_JOURNAL_ENTRY_COMMENT_FULFILLED,
        payload: {
          data: response.data,
          journalEntryId: values.entryId,
          journalEntryCommentId: values.commentId,
        },
      });
      showSuccessToast('Comment updated successfully.');
    })
    .catch((err) => {
      dispatch({
        type: EDIT_JOURNAL_ENTRY_COMMENT_REJECTED,
        payload: {
          entryId: values.entryId,
          err,
        },
      });
      showErrorToast(
        'There was an error updating your comment. Please try again.',
      );
    });
};

export const deleteJournalEntryComment = (accountCode, values) => (
  dispatch,
  getState,
) => {
  const { currentUser } = getState().auth.data;
  const { currentAthlete } = getState().journal.data;
  dispatch({ type: DELETE_JOURNAL_ENTRY_COMMENT_START });
  let uri = `/accounts/${accountCode}/journals/entries/${values.entryId}/comments/${values.commentId}/delete`;
  if (
    currentUser.admin < 1
    || (currentAthlete?.id === currentUser?.id)
  ) {
    uri = `/me${uri}`;
  }
  axiosAuthed
    .patch(uri)
    .then(() => {
      dispatch({
        type: DELETE_JOURNAL_ENTRY_COMMENT_FULFILLED,
        payload: {
          journalEntryCommentId: values.commentId,
          journalEntryId: values.entryId,
        },
      });
      showSuccessToast('Comment deleted successfully.');
    })
    .catch((err) => {
      dispatch({
        type: DELETE_JOURNAL_ENTRY_COMMENT_REJECTED,
        payload: {
          entryId: values.entryId,
          err,
        },
      });
      showErrorToast(
        'There was an error deleting your comment. Please try again.',
      );
    });
};

export const setReportPostId = (type, id) => (dispatch) => {
  dispatch({
    type: SET_REPORT_POST_ID,
    payload: { type, id },
  });
};

export const submitSupport = (values) => (dispatch) => {
  dispatch({ type: SUBMIT_SUPPORT_START });
  axiosAuthed
    .post('/support', values)
    .then((response) => {
      dispatch({
        type: SUBMIT_SUPPORT_FULFILLED,
        payload: response.data,
      });
      showSuccessToast('Message submitted successfully. Thank you.');
    })
    .catch((err) => {
      dispatch({
        type: SUBMIT_SUPPORT_REJECTED,
        payload: err,
      });
      showErrorToast(
        'There was an error submitting your message. Please try again.',
      );
    });
};

export const resetSubmitSupportError = () => (dispatch) => {
  dispatch({ type: RESET_SUPPORT_ERROR });
};
